import AltRoute from '@mui/icons-material/AltRoute';
import {Box} from '@mui/material';

import {IMAGES} from '@/constants/images';

interface IAvatarImage {
  image: string;
  backgroundColor: string;
}

export function parseAvatarImage(
  avatarImage: string | undefined,
): IAvatarImage | undefined {
  if (avatarImage == null || avatarImage === '') {
    return undefined;
  }
  try {
    const profileImage = JSON.parse(avatarImage) as IAvatarImage;
    if (!profileImage?.image) {
      return undefined;
    }
    switch (profileImage.image) {
      case 'AVATAR_1':
        return {
          image: IMAGES.AVATAR_1.src,
          backgroundColor: profileImage.backgroundColor,
        };
      case 'AVATAR_2':
        return {
          image: IMAGES.AVATAR_2.src,
          backgroundColor: profileImage.backgroundColor,
        };
      case 'AVATAR_3':
        return {
          image: IMAGES.AVATAR_3.src,
          backgroundColor: profileImage.backgroundColor,
        };
      case 'AVATAR_4':
        return {
          image: IMAGES.AVATAR_4.src,
          backgroundColor: profileImage.backgroundColor,
        };
      case 'AVATAR_5':
        return {
          image: IMAGES.AVATAR_5.src,
          backgroundColor: profileImage.backgroundColor,
        };
      case 'AVATAR_6':
        return {
          image: IMAGES.AVATAR_6.src,
          backgroundColor: profileImage.backgroundColor,
        };
      case 'AVATAR_7':
        return {
          image: IMAGES.AVATAR_7.src,
          backgroundColor: profileImage.backgroundColor,
        };
      default:
        return undefined;
    }
  } catch {
    return undefined;
  }
}

export const getAvatarImage = (
  avatarImage: string | undefined,
  initials: string,
) => {
  const parsedAvatarImage = parseAvatarImage(avatarImage);
  return (
    <Box className="splits-confirmation-avatar-wrap">
      {parsedAvatarImage ? (
        <div
          className="splits-confirmation-avatar splits-confirmation-avatar-img"
          style={{
            backgroundColor: parsedAvatarImage.backgroundColor,
          }}>
          <img
            src={parsedAvatarImage.image}
            alt="avatar"
            width={'70%'}
            height={'70%'}
          />
        </div>
      ) : (
        <div className="splits-confirmation-avatar splits-confirmation-avatar-mascot">
          <AltRoute className="splits-confirmation-avatar-alt-route" />
        </div>
      )}
      <span className="splits-landing-avatar-badge">{initials}</span>
    </Box>
  );
};
